<div class="card mb-3">
    <div class="widget--title">
        <a class="href" [routerLink]="['/stock-recommendation']" title="Hisse Önerileri"><h4 class="info-detail-title" >Hisse Önerileri</h4></a>
    </div>
    <ul class="list m-2">
        <ng-template ngFor let-bfl [ngForOf]="brokerageFirmList" let-i="index" [ngForTrackBy]="trackByFnBrokerageFirm">
            <li class="list-group-item-light" ><a class='href' [routerLink]="['/stock-recommendation/araci-kurum',bfl?.url]" title="{{bfl?.name}}">{{bfl?.name}}</a></li>
        </ng-template>                       
    </ul>
</div>
